import { render, staticRenderFns } from "./Memorama.vue?vue&type=template&id=1a14bfe3&"
import script from "./Memorama.vue?vue&type=script&lang=js&"
export * from "./Memorama.vue?vue&type=script&lang=js&"
import style0 from "./Memorama.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports